module.exports = __webpack_public_path__ + "img/Stellenausschreibungen.d5006fa6.gif";